<template>
  <div class="Users">
    <div class="content-info">
      <div class="">
        <p class="o-b t-i">Usuarios registrados</p>

        <div class="top-buttons">
          <div class="c-i-c">
            <p class="o-b t-u-c">Total usuarios: {{ usersCount }}</p>
          </div>
          <button @click="exportCSV" class="o-b but-r" id="basic-addon1">Exportar EXCEL</button>
        </div>

        <div class="b-c">
          <p class="o-b sub-t">Buscar nombre, apellido, correo o teléfono</p>
          <div class="m-top form-search-m">
            <div class="input-group">
              <div class="c-f-g">
                <img class="i-f-s" src="@/assets/images/search.png" alt="src" />
              </div>
              <input v-model="searchText" @keyup.enter="buscar" type="text" class="form-control i-s c-f-g" placeholder="Ingresa los términos de búsqueda" aria-label="Username" aria-describedby="basic-addon1" />
              <button v-on:click="buscar" class="btn-f but-g" id="basic-addon1">Buscar</button>
            </div>
          </div>
        </div>

        <div class="b-c">
          <p class="o-b sub-t">Usuarios registrados</p>
          <div class="text-center m-top" v-if="users.length == 0">Sin resultados</div>
          <div class="text-center" v-else>
            <div class="f-r">
              <p class="o-b sub-t">Ordenar por:</p>
              <select class="select-css" v-model="filterText" v-on:change="filter" name="nombre">
                <option selected value="">-- Selecciona una opción --</option>
                <option value="name">Nombre</option>
                <option value="username">Correo electrónico</option>
                <option value="createdAt" selected="selected">Fecha de registro</option>
              </select>
            </div>

            <table class="table table-light">
              <thead>
                <tr>
                  <th scope="col">Fecha de registro</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Correo electrónico</th>
                  <th scope="col">Teléfono</th>
                  <th scope="col">Fuente</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(user, index) in users" :key="index">
                  <td>{{ user.createdAt }}</td>
                  <td>{{ user.unmaskedFullname }}</td>
                  <td>{{ user.email }}</td>
                  <td>{{ user.phone }}</td>
                  <td>{{ user.source }}</td>
                  <td>
                    <router-link :to="{ name: 'DetailU', params: { id: user.id } }">
                      <button class="btn-actions">
                        <img src="@/assets/images/acciones.png" alt="acciones" />
                      </button>
                    </router-link>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="pag">
              <ul>
                <a v-if="currentPage != 0" @click="loadPage(currentPage - 1)" class="btn-page">Atras</a>
                <li v-for="(pageNumber, index) in pages" :key="index">
                  <a @click="loadPage(index)" :class="{ current: currentPage === index }"> {{ index + 1 }} </a>
                </li>
                <a v-if="pages != currentPage + 1" @click="loadPage(currentPage + 1)" class="btn-page">Siguiente</a>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import User from '../parse/models/User'
import XLSX from 'xlsx';

export default {
  name: 'Users',
  components: {
  },
  data() {
    return {
      usersCount: 0,
      users: [],
      searchText: "",
      filterText: "",
      currentPage: 0,
      itemsPerPage: 100,
    }
  },
  computed: {
    pages() {
      return Math.ceil(this.usersCount / this.itemsPerPage)
    }
  },
  beforeMount() {
    User.load(this.itemsPerPage, this.currentPage).then((users) => { this.users = users })
    User.count().then((count) => this.usersCount = count)
  },
  methods: {
    async loadPage(page) {
      this.currentPage = page
      let skip = page * this.itemsPerPage
      this.users = await User.reload(this.itemsPerPage, skip)
    },
    async buscar() {
      this.users = await User.search(this.searchText)
    },
    async filter() {
      this.users = await User.filter(this.filterText)
    },
    async exportCSV() {
      let users = await User.reload(10000)
      let data = users.map(user => ({
        "Fecha de registro": user.createdAt,
        "Nombre": user.unmaskedFullname,
        "Correo electrónico": user.email,
        "Teléfono": user.phone,
        "Fecha de nacimiento": user.birthday,
        "Fuente": user.source
      }))

      const workbook = XLSX.utils.book_new()
      const filename = 'Reporte'
      XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(data), filename)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
    }
  }
}
</script>

<style scoped>
.top-buttons {
  display: flex;
}

.top-buttons button{
  background: #e96369;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
  font-weight: 400;
  margin-left: 10px;
}

.btn-page {
  padding: 10px;
  color: #000 !important;
  cursor: pointer;
}

.padding {
  margin: 1em 0 1em 0;
}

.pag {
  text-align: right;
}

.pag a {
  color: #999;
}
.pag .current {
  color: #14fc78;
}
.pag ul {
  padding: 0;
  list-style-type: none;
}
.pag li {
  display: inline;
  margin: 5px 5px;
}

.pag a.first::after {
  content: '...';
}

.pag a.last::before {
  content: '...';
}

.select-css {
  font-size: 16px;
  font-weight: 400;
  color: #444;
  line-height: 1.3;
  padding: 0.4em 1.4em 0.3em 0.8em;
  width: 300px;
  max-width: 100%;
  box-sizing: border-box;
  margin: 20px 0;
  border: none;
  box-shadow: 0 1px 0 1px rgba(0, 0, 0, 0.03);
  border-radius: 0.3em;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-color: #f3f3f3;
  background-image: url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23007CB2%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E'),
    linear-gradient(to bottom, #f3f3f3 0%, #f3f3f3 100%);
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}
.select-css::-ms-expand {
  display: none;
}
.select-css:hover {
  border-color: #888;
}
.select-css:focus {
  border-color: #aaa;
  box-shadow: 0 0 1px 3px rgba(59, 153, 252, 0.7);
  box-shadow: 0 0 0 3px -moz-mac-focusring;
  color: #222;
  outline: none;
}
.select-css option {
  font-weight: normal;
}

.m-r {
  margin-right: 50px;
}

.dropdown-menu {
  width: 120px;
}

/* Container */

.content-info {
  margin-left: 310px;
  margin-right: 50px;
}

.c-i-c {
  width: 235px;
  height: 51px;
  background: #000;
  text-align: center;
  border-radius: 10px;
}

.t-u-c {
  padding-top: 14px;
  color: #fff;
  font-size: 16px;
}

.b-c {
  margin-right: 50px;
  margin-top: 37px;
  border: 1px solid #f6f6f6;
  -webkit-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  -moz-box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  box-shadow: 0px 3px 5px 0px rgba(151, 151, 151, 1);
  padding: 15px;
}

.sub-t {
  font-size: 18px;
  display: inline;
}

.i-f-s {
  width: 25px;
  margin-top: 5px;
  margin-left: 10px;
  margin-right: 10px;
}

.c-f-g {
  background: #f3f3f3;
  border: none;
  padding: 2px;
  height: 40px;
}

.but-g {
  background: #85eeb3;
  color: #fff;
  border: 0;
  width: 140px;
  height: 40px;
  border-radius: 10px;
}
.but-g:hover {
  background: #14fc78;
}

.btn-f {
  margin: 0 40px 0 20px;
}

.f-r {
  float: right;
}

.table {
  border: 1px solid #f6f6f6;
  text-align: center;
}

.btn-actions {
  background: #fff;
  border: none;
}
</style>
